import React from 'react';
import PropTypes from 'prop-types';

const AICard = ({ title, imageUrl, onClick }) => {
  const handleKey = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick && onClick(e);
    }
  };
  return (
    <div
      className="ai-card g-card"
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={handleKey}
    >
      <div className="ai-card__image">
        <img
          src={imageUrl || '/assets/svg/immagine.svg'}
          alt={title}
          loading="lazy"
        />
        <div className="ai-card__hover" aria-hidden="true">
          <span className="ai-card__pill">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              aria-hidden="true"
              focusable="false"
            >
              <path
                fill="currentColor"
                d="M12 5c-5 0-9 5-9 7s4 7 9 7 9-5 9-7-4-7-9-7Zm0 12a5 5 0 1 1 .001-10.001A5 5 0 0 1 12 17Zm0-8a3 3 0 1 0 .001 6.001A3 3 0 0 0 12 9Z"
              />
            </svg>
            <span className="ai-card__pill-text">Vedi un esempio</span>
          </span>
        </div>
      </div>
      <div className="ai-card__meta">
        <div className="ai-card__title">{title}</div>
      </div>
    </div>
  );
};

AICard.propTypes = {
  title: PropTypes.string.isRequired,
  imageUrl: PropTypes.string,
  onClick: PropTypes.func,
};

export default AICard;
